export async function http(input, init = {}) {
  if (window.location.pathname !== '/500') {
    sessionStorage.setItem(
      'lastPath',
      window.location.pathname + window.location.search
    );
  }

  // TODO to clarify the logic for now, and disable 500 error handling for now
  try {
    const res = await fetch(input, init);

    //   if (res.status >= 500) {
    //     window.location.replace('/500');
    //     throw new Error(`Server error ${res.status}`);
    //   }

    return res;
  } catch (e) {
    //   window.location.replace('/500');
    throw e;
  }
}
